/**
 * List of application errors related to Customers. Maps to FidelityErrorCodes on API
 */
export const CUSTOMER_ERRORS = {
    MISSING_CONSENT: 'FE-C001',
    USER_NOT_VALID: 'FE-C002',
    CONFIRMATION_TOKEN_EXPIRED_OR_NOT_FOUND: 'FE-C003',
    CUSTOMER_ALREADY_CONFIRMED: 'FE-C004',
    NO_CARD_TYPE_FOUND: 'FE-C005',
    EMAIL_ALREADY_IN_USE: 'FE-C006',
    USER_NOT_CONFIRMED: 'FE-C009',
};
